export const GROUP_LABELS: { [key: string]: string } = {
  CUSTOMERS: 'Clientes',
  PORTFOLIO: 'Portfólios',
  CAMPAIGNS: 'Campanhas',
  EXECUTION: 'Atendimentos',
  OPTIONS: 'Opções de tabulação',
  USERS: 'Usuários',
  TEAMS: 'Equipes',
  SALESFUNNELS: 'Funil de vendas',
  WALKIN: 'Atendimento avulso',
};
